import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';


export default function PrintLicenses({licenses}) {
  const { t } = useTranslation();


  useEffect(() => { // Handle print
    const beforePrint = () => {
      // Force landscape printing so everything fits
      const css = '@media print { @page { size: landscape } }';
      const style = document.createElement('style');

      style.media = 'print';
      style.id = 'print-landscape';
      style.appendChild(document.createTextNode(css));

      document.head.appendChild(style);
      document.getElementById('print').style.display = 'block';
    };

    const afterPrint = () => {
      document.getElementById('print-landscape').remove();
      document.getElementById('print').style.display = 'none';
    };

    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);

    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  }, []);


  return (
    <div id="print">
      <table id="print__header">
        <thead>
          <tr>
            <th id="print__logo">
              <img src="/assets/images/logo.png" alt="Logo"/>
              <p style={{display: 'none' /* used as brand name in excel file */}}>SoftThinks</p>
            </th>
            <th style={{fontSize: '24px', fontWeight: '600'}}>{t('global.dashboard')}</th>
          </tr>
          {/* Spacing */}<tr/><tr/>
        </thead>

        <tbody style={{fontWeight: '600'}}>
          <tr>
            <td>{t('admin.licenses.print.header', {s: licenses.length > 1 ? 's' : ''})}</td>
            <td>{licenses.length}</td>
          </tr>
          {/* Spacing */}<tr/><tr/><tr/>
        </tbody>
      </table>

      <table id="print__content">
        <thead>
          <tr>
            <th style={{textAlign: 'center', width: '5%'}}>{t('admin.licenses.columns.active')}</th>
            <th className="separation"/>

            <th style={{textAlign: 'left', width: '15%'}}>{t('admin.licenses.columns.group')}</th>
            <th style={{textAlign: 'right', width: '20%'}}>{t('admin.licenses.columns.label')}</th>
            <th className="separation"/>

            <th style={{textAlign: 'left', width: '23%'}}>{t('admin.licenses.columns.name')}</th>
            <th style={{textAlign: 'right', width: '12%'}}>{t('admin.licenses.columns.ip')}</th>
            <th className="separation"/>

            <th style={{textAlign: 'left', width: '4%'}}>{t('admin.licenses.columns.db_type')}</th>
            {/* <th style={{textAlign: 'left', width: '3%'}}>{t('admin.licenses.columns.activity_pc')}</th>
            <th style={{textAlign: 'right', width: '3%'}}>{t('admin.licenses.columns.activity_mobile')}</th> */}
            <th className="separation"/>

            <th style={{textAlign: 'left', width: '25%'}}>{t('admin.licenses.columns.mce_location')}</th>
          </tr>
        </thead>

        <tbody>
          {licenses.map(lic => (
            <tr style={{margin: '10px 0'}} key={lic.id}>
              <td style={{textAlign: 'center'}}>{t('global.' + (lic.enabled ? 'yes' : 'no'))}</td>
              <td className="separation"/>

              <td style={{textAlign: 'left'}}>{lic.group}</td>
              <td style={{textAlign: 'right'}}>{lic.label}</td>
              <td className="separation"/>

              <td style={{textAlign: 'left'}}>{lic.name}</td>
              <td style={{textAlign: 'right'}}>{lic.ip}</td>
              <td className="separation"/>

              <td style={{textAlign: 'left'}}>{lic.dbType}</td>
              <td style={{textAlign: 'left'}}>{lic.activityPc}</td>
              <td style={{textAlign: 'right'}}>{lic.activityMobile}</td>
              <td className="separation"/>

              <td style={{textAlign: 'left'}}>{lic.mceLocation}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}